import digitalData from 'digital-data';
import { NOT_APPLICABLE } from '../constants';

export const ratingsReviews = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('@@RATINGS-REVIEWS/EVENT', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@RATINGS-REVIEWS/EVENT is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('ratings-reviews.event', ({ output }) => {

    let componentName = '';
    let elementName = '';
    let moduleName = '';

    const { origin, location, value, eventType } = output;
    switch (location) {
      case 'search': {
        componentName = 'search reviews';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'filter': {
        componentName = 'filter reviews';
        elementName = value || NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'writereview': {
        componentName = 'write a review';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'writereviewoverlay': {
        componentName = 'write a review overlay';
        elementName = value || NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'keyword': {
        componentName = 'keyword';
        elementName = value;
        moduleName = origin;
        break;
      }
      case 'sort': {
        componentName = 'sort by';
        elementName = value;
        moduleName = origin;
        break;
      }
      case 'badge': {
        componentName = 'badge';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'media': {
        componentName = 'media';
        elementName = value;
        moduleName = origin;
        break;
      }
      case 'readmore': {
        componentName = 'read more';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'helpful': {
        componentName = 'was this helpful';
        elementName = value;
        moduleName = origin;
        break;
      }
      case 'profile': {
        componentName = 'profile';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'pagination': {
        componentName = 'pagination';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'starrating': {
        componentName = 'star rating';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'sentiment': {
        componentName = value;
        elementName = NOT_APPLICABLE;
        moduleName = origin;
        break;
      }
      case 'zone a': {
        componentName = value;
        elementName = NOT_APPLICABLE;
        moduleName = 'zone a';
        break;
      }
      default: {
        componentName = 'search reviews';
        elementName = NOT_APPLICABLE;
        moduleName = origin;
      }
    }

    (digitalData?.event || []).push({
      category: {
        primaryCategory: 'button submission'
      },
      eventInfo: {
        eventName: 'ugc click'
      },
      content: {
        ugc: [{
          module: moduleName,
          component: componentName,
          element: elementName
        }]
      }
    });
  });
};
